import React from "react";

const MandatoryLabel = () => {
    return <span>*</span>;
};

export default MandatoryLabel;
